import { CHART_AXIS_TICK_PROPS } from '../Chart.constants'

// Recharts names the layout after the category axis: `vertical` draws
// horizontal bars, `horizontal` draws columns.
export const CHART_BAR_LAYOUT = {
  columns: 'horizontal',
  rows: 'vertical',
}

export const BAR_CHART_DEFAULT_PROPS = {
  barCategoryGap: 8,
  margin: { bottom: 0, left: 0, right: 0, top: 0 },
}

export const BAR_CHART_CATEGORY_AXIS_DEFAULT_PROPS = {
  axisLine: false,
  tickLine: false,
}

export const BAR_CHART_Y_AXIS_DEFAULT_PROPS = {
  ...BAR_CHART_CATEGORY_AXIS_DEFAULT_PROPS,
  width: 110,
}

export const BAR_CHART_X_AXIS_DEFAULT_PROPS = {
  ...BAR_CHART_CATEGORY_AXIS_DEFAULT_PROPS,
  tick: CHART_AXIS_TICK_PROPS,
}

export const BAR_CHART_TOOLTIP_DEFAULT_PROPS = { cursor: false }

export const BAR_DEFAULT_PROPS = { isAnimationActive: false, radius: 6 }
